import { Button, ButtonGroup, Popover } from '@moleculeone/ui';
import { Mol } from '@retro-ui/api-contract';
import { useState } from 'react';

import { EditorMode, EditorModeType } from '../../utils/molecule-object/reducer/mode-types';
import { PeriodicTable } from '../PeriodicTable/PeriodicTable';

import { Atom } from './Atom';

const buttonCss = {
  borderRadius: '$small',
};

const symbolList = ['C', 'N', 'S', 'F', 'P', 'O'];

type CommonAtomsProps = {
  onPickAtom: (mol: Mol) => void;
  mode: EditorMode;
};
export const CommonAtoms = ({ onPickAtom, mode }: CommonAtomsProps) => {
  const [periodicTableOpen, setPeriodicTableOpen] = useState(false);

  return (
    <ButtonGroup direction="column">
      <Popover
        hasArrow
        trigger={<Button css={buttonCss} weight="minimal" icon="grid_on" active={periodicTableOpen} />}
        contentProps={{
          sideOffset: 5,
          side: 'left',
          css: {
            width: 'auto',
          },
        }}
        isOpen={periodicTableOpen}
        onOpenChange={open => {
          setPeriodicTableOpen(open);
        }}
      >
        <PeriodicTable
          onPickAtom={mol => {
            setPeriodicTableOpen(false);
            onPickAtom(mol);
          }}
        />
      </Popover>

      {symbolList.map(symbol => (
        <Atom
          symbol={symbol}
          onPickAtom={onPickAtom}
          key={symbol}
          active={mode.type === EditorModeType.FRAGMENT_ATOM_MODE && mode.data.fragment.atoms[0]?.element === symbol}
        />
      ))}
    </ButtonGroup>
  );
};
